import { useMediaQuery } from '@mui/material'
import { PureLightTheme } from '../../../styles/theme'
import { DesktopCard } from './Desktop'
import { MobileCard } from './Mobile'
import type { TeamDescription } from '../../../types/entitys/teams'

type TeamProps = {
  team: TeamDescription
}

export const TeamItem = ({ team }: TeamProps) => {
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('sm'))

  return isMobile ? <MobileCard team={team} /> : <DesktopCard team={team} />
}
